import { api, handleResponse, handleError } from "./apiServices";

export const merchantRegister = data =>
  api()
    .post(`/api/merchant/auth/register`, data)
    .then(handleResponse)
    .catch(handleError);

export const userlist = (token, data) =>
  api(token)
    .post(`/api/user/userProfile/getalluser`, data)
    .then(handleResponse)
    .catch(handleError);
